<div [class]="trafficType" [style]="style" class="phone">
	<div class="sender">
		{{ sender }}
	</div>
	<div class="write-message-hint">
		{{ 'templates.writeMessage' | translate }}
	</div>
	@if (file) {
		<div class="stub">
			<div class="note-section">
				<span class="title">{{ 'campaigns.sentFromFile' | translate }}</span> <br />
				<div class="note">{{ 'campaigns.sentFromFileNote' | translate }}</div>
			</div>
			<button (click)="download()" class="reset download-section" data-testid="downloadFileBtn">
				<div class="icon-round">
					<alaris-icon name="icon-import"></alaris-icon>
				</div>
				{{ 'actions.downloadFile' | translate }}
				<span class="bytes">{{ formatBytes(file.size) }}</span>
			</button>
		</div>
	} @else {
		<div class="message-box">
			<div class="today">{{ 'gl.today' | translate }}</div>
			<div class="message">
				@if (
					trafficType === TrafficType.WHATSAPP && whatsappSettings?.header?.value && whatsappSettings?.header?.type
				) {
					@switch (whatsappSettings!.header!.type) {
						@case (WhatsappHeaderType.TEXT) {
							<div [innerHTML]="whatsappHeaderInnerHTML()" class="whatsapp-header-text"></div>
						}
						@case (WhatsappHeaderType.GEOLOCATION) {
							<a [href]="createWhatsappGeoHref()" class="whatsapp-header-geo" target="_blank">
								{{ whatsappSettings?.header?.value }}
							</a>
						}
						@case (WhatsappHeaderType.URL) {
							@switch (whatsappFileUrlInfo()?.type) {
								@case (WhatsappFileType.IMAGE) {
									<img [alt]="'templates.altText' | translate" [src]="whatsappSettings?.header?.value" />
								}
								@case (WhatsappFileType.DOCUMENT) {
									<div class="whatsapp-document">
										<alaris-icon class="whatsapp-document__icon" name="icon-file"></alaris-icon>
										@let name = whatsappFileUrlInfo()?.name ?? '';
										<span [alarisTooltip]="name" [overflow]="true" class="text-truncate">{{ name }}</span>
									</div>
								}
							}
						}
					}
				}
				<div
					[innerHTML]="isWhatsappAuthentication ? whatsappAuthMessageInnerHTML() : messageInnerHTML()"
					class="text"
				></div>
				@switch (trafficType) {
					@case (TrafficType.SMS) {
						<alaris-icon name="message-sms-tail" class="message__sms-tail"></alaris-icon>
					}
					@case (TrafficType.VIBER) {
						@if (imageUrl) {
							<img [alt]="'templates.altText' | translate" [src]="imageUrl" />
						}
						@if (buttonCaption) {
							<a [attr.href]="buttonActionUrl" class="viber-anchor" target="_blank">
								{{ buttonCaption }}
							</a>
						}
						<div class="time time__whatsapp-viber">{{ today | date: 'HH:mm' }}</div>
					}
					@case (TrafficType.WHATSAPP) {
						<alaris-icon name="message-whatsapp-tail" class="message__whatsapp-tail"></alaris-icon>
						@if (whatsappSettings?.footer) {
							<div class="whatsapp-footer-text">{{ whatsappSettings?.footer }}</div>
						}
						@if (whatsappSettings?.category === WhatsappTemplateCategory.AUTHENTICATION) {
							<div class="whatsapp-footer-text">{{ createWhatsappAuthFooter() }}</div>
						}
						<div class="time time__whatsapp-viber">{{ today | date: 'HH:mm' }}</div>
						@if (whatsappSettings?.category === WhatsappTemplateCategory.AUTHENTICATION) {
							<button
								[cdkCopyToClipboard]="String(whatsappSettings?.authentication?.code)"
								class="whatsapp-button"
								data-testid="copyCodeBtn"
							>
								<alaris-icon name="icon-copy-simple"></alaris-icon>
								{{ 'enums.COPY_CODE' | translate }}
							</button>
						}

						@for (button of (whatsappSettings?.buttons ?? []).slice(0, whatsappMaxVisibleButtons()); track button) {
							@switch (button.type) {
								@case (WhatsappButtonType.PHONE) {
									<a [href]="'tel:+' + button.phone" class="whatsapp-button">
										<alaris-icon name="icon-phone"></alaris-icon>
										<span class="text-truncate">{{ button.name }}</span>
									</a>
								}
								@case (WhatsappButtonType.COPY_CODE) {
									<button [cdkCopyToClipboard]="button.code ?? ''" class="whatsapp-button" data-testid="copyCodeBtn">
										<alaris-icon name="icon-copy-simple"></alaris-icon>
										{{ 'enums.COPY_CODE' | translate }}
									</button>
								}
								@case (WhatsappButtonType.QUICK_REPLY) {
									<button class="whatsapp-button" data-testid="quickReplyBtn">
										<span class="text-truncate">{{ button.name }}</span>
									</button>
								}
								@case (WhatsappButtonType.URL) {
									<a
										[href]="button.url || shortenerUtils.extractShortLink(button.shortUrl ?? '')?.url"
										class="whatsapp-button"
										target="_blank"
									>
										<alaris-icon name="icon-new-tab"></alaris-icon>
										<span class="text-truncate">{{ button.name }}</span>
									</a>
								}
							}
						}
						@if ((whatsappSettings?.buttons ?? []).length > whatsappMaxVisibleButtons()) {
							<button
								(click)="whatsappMaxVisibleButtons.set(Infinity)"
								class="whatsapp-button"
								data-testid="seeAllOptionsBtn"
							>
								<alaris-icon name="icon-view-list"></alaris-icon>
								{{ 'templates.seeAllOptions' | translate }}
							</button>
						}
					}
				}
			</div>
			@if (trafficType === TrafficType.SMS) {
				<div class="time time__sms">{{ today | date: 'HH:mm' }}</div>
			}
		</div>
	}
</div>
